module.exports = __webpack_public_path__ + "img/D_Read_more_alcoholic.243dfb22.svg";